<template>
  <div>{{$t('label.disconnection')}}</div>
</template>

<script>
import { Logout } from "../services/account";
export default {
  name: "Logout",
  mounted() {
    this.logout();
    // this.$store.dispatch('user/logout')
    //   .then(() => {
    //     this.$router.push('/login');
    //   });
  },
  methods: {
    async logout() {
      await Logout();
      this.$router.toLogin();
    },
  },
};
</script>

<style scoped>
</style>
